import React from 'react'
import PropTypes from 'prop-types'
import Plot from 'react-plotly.js'
import * as utils from '../../utils/commonLayout'

class ScatterPlot extends React.Component {
    static propTypes = {
        data: PropTypes.array,
        onUMapSelected: PropTypes.func,
        onUMapDeselect: PropTypes.func,
        selectedPoints: PropTypes.array,
        selectedColor: PropTypes.string,
        annotationCount: PropTypes.number,
        isOpen: PropTypes.bool.isRequired
    }

    constructor (props) {
        super(props)
        this.state = {
            data: this.props.data,
            layout: null,
            config: {
                responsive: true,
                displaylogo: false,
                modeBarButtonsToRemove: ['toImage', 'autoScale2d', 'toggleSpikelines', 'hoverCompareCartesian', 'hoverClosestCartesian']
            },
            annotations: [],
            width: 0
         }
    }

    componentDidMount () {
        this.setState({data: this.props.data})
        this.setData()
    }

    componentDidUpdate (prevProps) {
        if (prevProps.selectedPoints !== this.props.selectedPoints || prevProps.annotationCount !== this.props.annotationCount || prevProps.isOpen !== this.props.isOpen) {
            this.setData()
        }
        if (prevProps.selectedColor !== this.props.selectedColor || prevProps.data !== this.props.data) {
            this.setState({data: this.props.data})
        }
    }

    setData = () => {
        let annotations = []
        let annotation = null
        this.props.selectedPoints && this.props.selectedPoints.map(pt => {
            if (pt.showTooltip) {
                annotation = {
                    x: pt.x,
                    y: pt.y,
                    xref: 'x',
                    yref: 'y',
                    text: `${pt.name}: ${pt.numAlignments}`,
                    showarrow: true,
                    font: {
                      color: '#000000'
                    },
                    arrowhead: 2,
                    xanchor: 'center',
                    yanchor: 'top',
                    bordercolor: '#000000',
                    borderwidth: 1,
                    borderpad: 1,
                    bgcolor: '#FFFFFF'
                }
                annotations.push(annotation)
            }
        })

        this.setState({
            layout: {
                width: this.state.width,
                height: 488,
                autosize: true,
                annotations: annotations,
                margin: {l: 10, r: 10, b: 30, t: 40},
                hovermode: 'closest',
                //hoverlabel: { bgcolor: '#FFF' },
                legend: {orientation: 'h', y: -0.3},
                xaxis: {
                    showgrid: true,
                    zeroline: false,
                    visible: false,
                    automargin: true
                },
                yaxis: {
                    showgrid: true,
                    zeroline: false,
                    visible: false,
                    automargin: true
                },
                template: utils.template_plotly
            }
        })
    }

    onSelected = (data) => {
        this.props.onUMapSelected(data)
    }

    onDeselect = () => {
        this.props.onUMapDeselect()
    }

    render () {
        return ((this.props.data && this.state.layout) &&
          <Plot
            data={this.props.data}
            layout={this.state.layout}
            config={this.state.config}
            useResizeHandler
            style={{ width: '100%', height: '100%' }}
            onInitialized={(figure) => this.setState(figure)}
            onUpdate={(figure) => this.setState(figure)}
            onSelected={data => this.onSelected(data)}
            onDeselect={data => this.onDeselect(data)}
            />
        )
    }
}

export default ScatterPlot